import React, { ReactElement } from 'react';
import {
  Accordion, AccordionSection,
  Heading, Tab, TabGroup,
} from 'idsk-react-components';
import DOMPurify from 'dompurify';
import he from 'he';
import Oblast from '../../model/Oblast';
import './NajcastejsieOtazky.scss';

interface Props {
  data: Oblast[] | null | undefined
}

const NajcastejsieOtazky = (
  { data }
    : Props,
): ReactElement => {
  function decodeHtml(htmlContent: string): string {
    return he.decode(htmlContent)
      .replace(/(<([^>]+)>)/ig, '');
  }

  return (
    <>
      <div className="najcastejsie-otazky">
        <Heading size="xl">Najčastejšie otázky</Heading>
        {data && (
          <>
            <TabGroup>
              {data.map(oblast => (
                <Tab id={oblast.id} title={oblast.nazov} key={oblast.id}>
                  <Accordion>
                    {oblast.order.map(code => {
                      const otazka = oblast.otazky.filter(o => o.code === code)[0];
                      return (
                        <AccordionSection heading={decodeHtml(otazka.nazov)} key={otazka.id}>
                          {/* eslint-disable-next-line react/no-danger */}
                          <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(otazka.popis) }} />
                        </AccordionSection>
                      );
                    })}
                  </Accordion>
                </Tab>
              ))}
            </TabGroup>
          </>
        )}
      </div>
    </>
  );
};

export default NajcastejsieOtazky;
